import styled from 'styled-components';
import { COLORS } from '../../colors';

const StyledHome = styled.div`

  section {
    .titles {
      max-width: 600px;
      margin-bottom: 1rem;
      h1 {
        font-size: 3rem;
        line-height: 2.9rem;
        margin-bottom: 1rem;
        //only smartphone
        @media only screen and (max-width: 600px) {
          font-size: 38px;
          line-height: 35px;
        }
      }
      p {
        font-weight: 300;
      }
      margin-left: auto;
      margin-right: auto;
    }
  }

  section#main {
    display: flex;
    justify-content: center;
    padding-top: 23vh;
    min-height: 90vh;
    position: relative;

    .absolute-illustration {
      position: absolute;
      img {
        position: absolute;
        top: -127px;
        right: -300px;
        width: 180px;
        height: 180px;
        z-index: -1;

        //only smartphone
        @media only screen and (max-width: 600px) {
          top: -130px;
          right: -110px;
          width: 140px;
          height: 140px;
        }
      }
    }

    .counter {
      color: white;
      width: fit-content;
      padding: 5px 10px;
      font-size: 14px;
      border-radius: 12px;
      margin: auto;
      margin-bottom: 1rem;
      border: solid 1px ${COLORS.primary};
      color: ${COLORS.primary}
    }
    //only smartphone
    @media only screen and (max-width: 600px) {
      padding-left: 2rem;
      padding-right: 2rem;
    }
    .titles {
      h1 span {
        background: #ff0090;
        background: linear-gradient(to right, #ff0090 0%, #00d4ff 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      //only smartphone
      @media only screen and (max-width: 600px) {
        h1 span#vector, h1 span#illustrations {
          font-size: 2.5rem;
        }
      }
    }
    
    .inputs {
      display: flex;
      gap: 1rem;
      position: relative;
      textarea {
        display: block;
        margin: auto;
        width: 100%;
        text-align: center;
        line-height: 1.0rem;
        padding-top: 1.0rem;
        background-color: white;
        border-radius: 12px;
        border: none;
        font-size: 18px;
        box-sizing: border-box;
        max-height: 300px;
        z-index: 9;
      }
      textarea.highlighted {
        border: 2px solid ${COLORS.primary} !important;
        box-shadow: 0 0 5px ${COLORS.primary};
      }
      button {
        background-color: ${COLORS.primary};
        border: none;
        border-radius: 12px;
        padding: 0rem 1rem;
      }
    }
    .tips {
      button {
        background-color: transparent;
        border: none;
        color: ${COLORS.primary};
        font-size: 16px;
        cursor: pointer;
        text-decoration: underline;
        padding: 1rem;
        svg {
          margin-right: 5px;
        }
      }
    }
  }

  section#whyvector {  
    //only smartphone
    @media only screen and (max-width: 600px) {
      padding-left: 2rem;
      padding-right: 2rem;
    }

    padding-top: 6rem;
    padding-bottom: 6rem;

    .explanation {
      max-width: 500px;
      margin: auto;
      p {
        padding: 1rem;
      }
    }

    table {
      margin: auto;
      padding: 1rem;
      //only smartphone
      @media only screen and (max-width: 600px) {
        padding: 0rem;
      }
      svg {
        width: 25px;
        height: auto;
      }
      td, th {
        border-radius: 12px;
        padding: 0.5rem 1.5rem;
        border: solid 1px ${COLORS.darkerBlue};
        //only smartphone
        @media only screen and (max-width: 600px) {
          font-size: 14px;
          padding: 0.5rem 1rem;
        }
      }
      thead {
        th {
          color: white;
        } 
      }
    }

    img.whyVectorImg {
      width: 200px;
    }
    h1 {
      font-size: 42px;
      line-height: 40px;
    }
  }

  section#howitworks{
    padding-top: 6rem;
    padding-bottom: 6rem;
    background-color: ${COLORS.darkerBlue};
    
    .howitworks-container{
      padding-top: 1rem;
      margin: auto;
      display: flex;
      flex-direction: row;
      justify-content: center;
      flex-wrap: wrap;
      gap: 1rem;
      //only smartphone
      @media only screen and (max-width: 600px) {
        flex-direction: column;
        padding: 2rem;
      }
      > div {
        width: 15%;
        max-width: 300px;
        //only smartphone
        @media only screen and (max-width: 600px) {
          width: 100%;
          max-width: 100%;
        }
        background-color: ${COLORS.darkBlue};
        padding: 1rem;
        border-radius: 12px;
        display: flex;
        flex-direction: column;
        box-sizing: border-box;

        h2 {
          font-size: 1.5rem;
          margin-bottom: 0.5rem;
        }
        p {
          font-size: 0.85rem;
        }
        img {
          width: 100%;
        }
        position: relative;

        .number {
          position: absolute;
          background-color: ${COLORS.primary};
          width: 35px;
          height: 35px;
          border-radius: 100%;
          top: 10px;
          left: 10px;
          span {
            font-weight: bold;
            color: white;
            font-size: 22px;
            line-height: 35px;
          }
        }
      }
    }
  }

  section#example {
    background-color: ${COLORS.darkerBlue};

    padding-top: 6rem;
    padding-bottom: 6rem;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    position: relative;

    //only smartphone
    @media only screen and (max-width: 600px) {
      padding: 2rem;
    }

    
    .examples {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      gap: 2rem;
      padding-top: 1rem;

      //only smartphone
      @media only screen and (max-width: 600px) {
        grid-template-columns: 1fr;
      }

      > div {
        p {
          padding-top: 0.5rem;
          font-size: 0.85rem;
        }
        img {
          border-radius: 12px;
          width: 250px;
        }
      }
    }
  }

  section#alltools {
    padding-top: 6rem;
    padding-bottom: 6rem;
    //only smartphone
    @media only screen and (max-width: 600px) {
      padding: 2rem;
      .cta {
        > div {
          width: 100%;
        }
      }
    }
    .cta {
      display: flex;
      flex-direction: column;
      gap: 1rem;
      align-items: center;
      justify-content: center;
    }
  }
 
  section#seenin{
    
    padding-top: 6rem;
    padding-bottom: 6rem;
    background-color: ${COLORS.darkBlueAlternative};
    .images {
      display: flex;
      width: 80vw;
      margin: auto;
      justify-content: center;
      align-items: center;

      //only smartphone
      @media only screen and (max-width: 600px) {
        width: 100%;
        flex-direction: column;
      }
      a {
        width: 15%;
        height: fit-content;
        margin: 1rem;
        //only smartphone
        @media only screen and (max-width: 600px) {
          width: 50%;
        }
        img {
          width: 100%;
          filter: grayscale(100%);
          
        }
      }
    }
  }
`

export {
  StyledHome
}